window.Vue = require('vue');
window.axios = require('axios');
window.lodash = require('lodash');

import VueYoutube from 'vue-youtube';
Vue.use(VueYoutube);

import VShowSlide from 'v-show-slide';
Vue.use(VShowSlide);

import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
//Vue.use(PerfectScrollbar);

Vue.use(PerfectScrollbar, { options: { 'wheelPropagation': false } });

Vue.component('zoa-donation-block', require('../vue/components/DonationBlock').default);
Vue.component('zoa-donation-amount', require('../vue/components/DonationAmount').default);
Vue.component('zoa-country-widget', require('../vue/components/CountryWidget').default);
Vue.component('zoa-map-wrapper', require('../vue/components/MapWrapper').default);
Vue.component('zoa-country-aside', require('../vue/components/CountryAside').default);
Vue.component('zoa-country-filters', require('../vue/components/CountryFilters').default);
Vue.component('zoa-selected-country', require('../vue/components/SelectedCountry').default);
Vue.component('zoa-specialism-tabs', require('../vue/components/SpecialismTabs').default);
Vue.component('zoa-specialism-tab-button', require('../vue/components/SpecialismTabButton').default);
Vue.component('zoa-headroom', require('../vue/components/Headroom').default);
Vue.component('zoa-youtube-wrapper', require('../vue/components/YoutubeWrapper').default);
Vue.component('zoa-tabs-component', require('../vue/components/TabsComponent').default);
Vue.component('zoa-tab-button', require('../vue/components/TabButton').default);
Vue.component('zoa-toggle', require('../vue/components/Toggle').default);
Vue.component('zoa-accordion', require('../vue/components/Accordion').default);
Vue.component('zoa-country-filter-buttton', require('../vue/components/CountryFilterButton').default);
Vue.component('zoa-active-country-teasers', require('../vue/components/ActiveCountryTeasers').default);

new Vue({
    'el': '#page-wrapper',

    comments: true,
});
